export default __webpack_public_path__ + "static/media/logo-loop-forever.2a73ddae.svg";